// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mediaGallery .pagesSearch, .mediaGallery .pageSearchTop, .mediaGallery .pagesSearchIcon{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.mediaGallery .pageSearchTop, .mediaGallery .pagesSearchIcon{
    gap: 8px;
}
.mediaGallery .pagesSearch .dropdown.dateDropdown {
    width: max-content;
}

.mediaGallery .dropdown-wrapper{
    width: 200px;
}
.mediaGallery .dropdown-wrapper .dropdown-header{
    width: 100%;
}

.mediaGallery .dropdown-wrapper .dropdown-item span{
    font-size: 14px;
}

.mediaGallery .deleteIcon {
    z-index: 7;
    cursor: pointer;
}

.mediaGallery .pagesTableList .pagesTableCheck input[type="checkbox"]:before {
    margin-left: 10px;
    margin-right: 10px;
}

.mediaGallery .pagesTableTop input[type="checkbox"]:before {
    margin-left: 10px;
    margin-right: 10px;
}

.mediaGallery .deleteIcon {
    line-height: 0;
}

.mediaGallery .list-search input[type="checkbox"]:before {
    position: relative;
}

.mediaGallery .fileUploadBox .uploadFileBlock {
    max-width: 770px;
    min-height: 206px;
    margin: 0 auto;
}

.mediaGallery .fileUploadBox.draging .uploadFileBlock {
    border-color: var(--purple);
}

.modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {
    width: 100%;
    background-color: transparent;
    border: none;
}

.modalPopup .mediaGallery .mediaContentWrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    height: 100%;
}

.dashboard.mediaGallery {
    padding: 30px 30px 100px;
}

.mediaGallery .modalHeader {
    margin-top: -5px;
}

.modalPopup .contentrow {
    padding: 20px 24px;
    border-bottom: 1px solid var(--lightgrey);
}

.mediaGallery button.selectFields,
.mediaGallery .media-grid-layout {
    background-color: var(--white);
}

.mediaGallery .uploadFileBlock {
    padding: 20px 10px;
}

.mediaGallery .newPageImageUploadText {
    padding-top: 0;
    margin-bottom: 0;
    text-align: center;
}

.modalPopup .mediaGallery {
    max-width: 1076px;
    margin: 0 auto;
    border: 1px solid var(--lightgrey);
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    background-color: var(--white);
    width: calc(100% - 30px);
    position: relative;
}

.modalPopup .popupBlock {
    max-width: 1076px;
    margin: auto;
    background-color: var(--white);
    padding: 0;
    border: 1px solid var(--lightgrey);
    border-radius: 6px;
    width: calc(100% - 30px);
    position: relative;
}

.mediaGallery .modalPopup {
    padding: 0;
    border: none;
    margin-top: 20px;
}

.mediaGallery .welcomeModal .primary-button {
    width: 50%;
}

.mediaGallery .welcomeModal .primary-button {
    padding: 8px 13px;
}

.modalPopup .mediaGallery .popupClose {
    cursor: pointer;
    margin-top: 15px;
    position: absolute;
    right: 15px;
}

.mediaGallery .deleteIcon img {
    top: 0;
}

.mediaGallery .pagesSearchgridIcon,
.mediaGallery .pagesSearchlistIcon {
    cursor: pointer;
}

.mediaGallery .pagesSearchbtn .pagesbtn {
    background-color: var(--black);
}

.mediaGallery .ulpoadImageBlock {
    padding-left: 36px;
    padding-right: 36px;
}

.mediaGallery .uploadingQueue .uploadThumbnail {
    background-color: var(--frostedwhite);
}

.mediaGallery .uploadingQueue .uploadThumbnail img {
    opacity: 0;
}


.pageSearchInput {
    position: relative;
}

.pageSearchInput img.pageSearchIcon {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.pageSearchInput input {
    max-width: 400px;
    width: 100%;
    height: 42px !important;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 5px 5px 6px 40px;
    outline: none;
    right: 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}

.pageSearchInput img {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.pageSearchInput input::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grey);
}

.newpageImageUpload.draging {
    border-color: var(--purple);
}

.modalPopup .file {
    width: calc(50% - 4px);
    position: relative;
}

.modalPopup .preview {
    width: 50%;
}

.modalPopup .modalImg {
    text-align: center;
    padding: 24px 19px 14px 24px;
    height: calc(100% - 58px);
    max-height: calc(404px + 91px);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.modalPopup .modalImg img {
    width: auto;
    height: auto;
    border-radius: 0;
    max-width: 100%;
    max-height: 100%;
}

.modalPopup .modalImg.type-doc img {
    object-fit: none;
}

.edit-media-popup .popupBlock-wrapper {
    background-color: var(--white);
    border-radius: 6px;
}

.modalPopup .modalInput::placeholder {
    color: var(--fiord);
}

.modalPopup .modalInput::-ms-input-placeholder {
    color: var(--fiord);
}

.modalPopup .modalInput {
    cursor: unset;
    width: 70%;
    padding: 10px;
    border: 1px solid var(--lightgrey) !important;
    border-radius: 5px;
    margin-right: 0;
    font-size: 14px;
    font-weight: 400;
    color: var(--fiord);
    outline: none;
    min-height: 40px;
    resize: none;
}
.modalPopup .modalInput.error-border {
    border-color: #d92d20 !important;
}

.modalPopup .title,
.modalPopup .formContent label,
.modalPopup .formContentbtn,
.file-wrapper .title,
.file-wrapper .formContent label,
.file-wrapper .formContentbtn {
    font-size: 14px;
    font-weight: 500;
    color: var(--charcoalblue);
}

.modalPopup .formContent {
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
}

.modalPopup .formContent.fromDesc {
    align-items: flex-start;
}

.modalPopup .formContent label {
    width: 100px;
    margin-right: 10px;
}

.modalPopup .formContent .formURL {
    width: calc(100% - 130px);
    position: relative;
}

.modalPopup .formContent .formURL .modalInput {
    width: 100%;
    padding-right: 60px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.modalPopup .modalContent {
    min-height: 370px;
    padding: 15px 24px;
}

.modalPopup .contentrow {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 10px 20px;
    flex-wrap: wrap;
    padding: 24px;
}

.modalPopup .modalContent .contentrow {
    padding: 0 0 15px;
}

.modalPopup .subtext {
    font-size: 14px;
    font-weight: 400;
    color: var(--fiord);
    margin-left: 6px;
}

.modalPopup .modalContentform {
    padding: 15px 0 0;
}

.modalPopup .formUrlImg {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 12px;
    margin-right: 12px;
    gap: 10px;
}

.modalPopup .formUrlImg a {
    display: inline-block;
    vertical-align: top;
    transition: all 0.2s linear;
    opacity: 1;
}

.modalPopup .formUrlImg a:hover {
    opacity: 0.5;
}

.modalPopup .modalHeader,
.modalPopup .contentrow {
    border-bottom: 1px solid var(--lightgrey);
    padding: 20px 24px;
    margin: 0;
}

.modalPopup .filename,
.modalPopup .previewname {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    color: var(--charcoalblue);
    word-break: break-all;
    padding-right: 15px;
    margin: 0;
}

.modalPopup .filename {
    padding-right: 0;
}

.modalPopup .popupBlock:after {
    content: "";
    background-color: #eaecf0;
    width: 1px;
    height: 100%;
    left: -10px;
    right: 0;
    margin: 0 auto;
    position: absolute;
    top: 0;
}

.modalPopup .popupBlock .popupBlock-wrapper {
    padding: 0;
    background-color: transparent;
    margin: 5px 5px 5px 0;
}

.modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {
    width: 100%;
    background-color: transparent;
    border: none;
}

.modalPopup .popupBlock-wrapper .tooltip-text:after {
    content: "";
    position: absolute;
    bottom: 100%;
    right: 30px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent var(--mistygray) transparent;
}

.modalPopup .popupBlock-wrapper .tooltip-text {
    position: absolute;
    right: 10px;
    font-size: 11px;
    background: var(--white);
    color: var(--cloudburst);
    padding: 6px 8px;
    border-radius: 6px;
    font-weight: 500;
    box-shadow: var(--tooltipboxshadow);
}

.modalPopup .btnGroupLink {
    text-align: center;
    margin-top: 0;
    border-top: 1px solid var(--lightgrey);
    padding: 24px 24px 19px;
    justify-content: space-between;
}

.modalPopup .btnGroupLink button{
    max-width: 50%;
}

.modalPopup .btnGroupLink .cancel-btn{
    background-color: var(--white);
    color: #000;
    border: 1px solid var(--grey);
    box-shadow: var(--boxshadow);
}

.modalPopup .modalActionsButtons,
.modalContent .modalActionsButtons ,
.modalPopup .modalDelete{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
}

.modalActionsButtons .modalDelete .settingPage-loader {
    display: inline-block;
    width: 20px;
    height: 20px;
    bottom: 0;
    margin-right: 8px;
    min-width: unset;
}

.modalActionsButtons .modalDelete .ring-loader {
    margin: 0;
    top: 2px;
}

.modalActionsButtons .modalDelete .ring-loader::before {
    border-color: var(--charcoalblue);
    border-width: 2px;
}

.btnGroupLink button{
    width: 50%;
    max-width: unset;
}

.modalPopup .modalDelete{
    gap: 0px;
    cursor: pointer;
}

.modalPopup .modalDelete img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
}

.modalPopup .modalDelete .settingPage-loader,
.modalActionsButtons .modalDelete .settingPage-loader {
    display: inline-block;
    width: 20px;
    height: 20px;
    bottom: 0;
    margin-right: 8px;
    min-width: unset;
}

.modalPopup .modalDelete .ring-loader,
.modalActionsButtons .modalDelete .ring-loader {
    margin: 0;
    top: 2px;
}

.modalPopup .modalDelete .ring-loader:before,
.modalActionsButtons .modalDelete .ring-loader::before {
    border-color: var(--charcoalblue);
    border-width: 2px;
}

.modalPopup .modalDelete .formContentbtn {
    display: inline-block;
    vertical-align: middle;
}

.mediaPopupContainer {
    position: fixed;
    z-index: 99;
    top: 0;
    display: flex;
    margin: auto;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
}

html:has(.mediaPopupContainer) {
    overflow: hidden;
}


.addNewMediaButton {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    box-shadow: 0 1px 3px #0000001a;
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
}

.modalPopup .desktop-view {
    display: flex;
}

.modalPopup .mobile-view{
    display: none;
}

@media screen and (max-width: 1100px) {
    .modalPopup .modalImg {
        padding: 24px 24px 19px;
    }

    .modalPopup .formContent .formURL {
        width: calc(100% - 152px);
    }

    .modalPopup .modalContent,
    .modalPopup .contentrow {
        padding: 15px;
        padding: 15px;
    }
}

@media screen and (max-width: 1024px) {
    .modalPopup .popupBlock .popupBlock-wrapper .mediaGallery .modalActions input {
        padding: 8px 13px;
    }
}

@media screen and (max-width: 991px) {
    .modalPopup .file .modalHeader {
        border-top: none;
        padding-right: 35px;
    }

    .modalPopup .modalInput {
        width: calc(100% - 80px);
    }

    .modalPopup .formContent .formURL {
        width: calc(100% - 80px);
    }

    .modalPopup .formContent {
        gap: 10px;
    }

    .modalPopup .modalContent {
        padding: 15px 24px 6px 24px;
    }

    .modalPopup .contentrow {
        padding: 0 0 15px 0;
    }

    .modalPopup .modalHeader {
        padding: 20px 24px;
    }

    .modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {
        height: 100%;
        margin: 0;
    }
}

@media screen and (max-width: 980px) {
    .pageSearchInput input {
        right: 0px;
        width: calc(100% - 20px);
    }

    .pageSearchInput img {
        position: absolute;
        left: 15px;
        top: 13px;
    }
}

@media screen and (max-width: 840px) {
    .pageSearchInput input {
        right: 0px;
    }

    .pageSearchInput img {
        left: 15px;
    }
}

@media screen and (max-width: 767px) {
    .modalPopup .desktop-view {
        display: none;
    }

    .modalPopup .mobile-view{
        display: flex;
    }

    .mediaGallery .pagesSearch {
        flex-direction: column;
    }

    .mediaGallery .pagesSearch .pagesSearchIcon {
        justify-content: flex-start;
        display: flex;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .mediaGallery .pageSearchInput .inputFields {
        width: 100%;
        max-width: 100%;
    }

    .mediaGallery .pagesSearch .list-search input[type="checkbox"] {
        width: auto;
    }

    .mediaGallery .modalPopup {
        margin-top: 0;
    }

    .modalPopup .mediaGallery {
        flex-direction: column;
        overflow-y: auto;
        padding: 0;
        width: calc(100% - 20px);
        margin: 10px auto;
        padding-bottom: 0;
        margin: 10px;
        height: calc(100% - 20px);
    }

    .modalPopup .mediaGallery .popupClose {
        position: absolute;
        top: 17px;
        right: 20px;
        display: block;
        margin-top: 0;
    }

    .mediaGallery .pageSearchTop .dropdown-wrapp {
        width: calc(50% - 5px);
    }

    .mediaGallery .pageSearchTop .dropdown-wrapp button {
        width: 100%;
        justify-content: space-between;
    }

    .mediaGallery .dropdown.addDropdown {
        width: 100%;
    }

    .mediaGallery .pageSearchTop, .mediaGallery .pageSearchTop .pageSearchInput {
        width: 100%;
    }

    .mediaGallery .ulpoadImageBlock {
        padding-left: 18px;
        padding-right: 18px;
    }

    .pageSearchInput input {
        right: 0px;
    }

    .pageSearchInput img {
        left: 15px;
    }

    .modalPopup .file {
        width: 100%;
        border-right: 0;
    }

    .modalPopup .preview {
        width: 100%;
    }

    .modalPopup .formContent {
        gap: 5px;
    }

    .modalPopup .popupBlock:after {
        display: none;
    }

    .modalPopup .popupBlock .popupBlock-wrapper {
        height: max-content;
    }

    .modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {
        flex-direction: column;
    }

    .modalPopup .modalContent{
        min-height: unset;
    }
}

@media screen and (max-width: 560px) {
    .modalPopup .formContent:last-child label {
        width: 100px;
    }

    .modalPopup .modalInput,
    .modalPopup .formContent .formURL {
        width: calc(100% - 105px);
    }

    .modalPopup .modalInput {
        margin-right: 0 !important;
    }
}

@media screen and (max-width: 320px) {
    .modalPopup .popupBlock .popupBlock-wrapper {
        height: calc(100dvh - 30px);
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Media/mediaGallery.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,UAAU;IACV,kCAAkC;IAClC,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,MAAM;AACV;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,gCAAgC;AACpC;;AAEA;;;;;;IAMI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,yCAAyC;IACzC,kBAAkB;IAClB,SAAS;AACb;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kEAAkE;AACtE;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,wBAAwB;IACxB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,MAAM;IACN,aAAa;IACb,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,aAAa;QACb,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,2BAA2B;QAC3B,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,UAAU;QACV,wBAAwB;QACxB,iBAAiB;QACjB,iBAAiB;QACjB,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".mediaGallery .pagesSearch, .mediaGallery .pageSearchTop, .mediaGallery .pagesSearchIcon{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.mediaGallery .pageSearchTop, .mediaGallery .pagesSearchIcon{\n    gap: 8px;\n}\n.mediaGallery .pagesSearch .dropdown.dateDropdown {\n    width: max-content;\n}\n\n.mediaGallery .dropdown-wrapper{\n    width: 200px;\n}\n.mediaGallery .dropdown-wrapper .dropdown-header{\n    width: 100%;\n}\n\n.mediaGallery .dropdown-wrapper .dropdown-item span{\n    font-size: 14px;\n}\n\n.mediaGallery .deleteIcon {\n    z-index: 7;\n    cursor: pointer;\n}\n\n.mediaGallery .pagesTableList .pagesTableCheck input[type=\"checkbox\"]:before {\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.mediaGallery .pagesTableTop input[type=\"checkbox\"]:before {\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.mediaGallery .deleteIcon {\n    line-height: 0;\n}\n\n.mediaGallery .list-search input[type=\"checkbox\"]:before {\n    position: relative;\n}\n\n.mediaGallery .fileUploadBox .uploadFileBlock {\n    max-width: 770px;\n    min-height: 206px;\n    margin: 0 auto;\n}\n\n.mediaGallery .fileUploadBox.draging .uploadFileBlock {\n    border-color: var(--purple);\n}\n\n.modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {\n    width: 100%;\n    background-color: transparent;\n    border: none;\n}\n\n.modalPopup .mediaGallery .mediaContentWrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: stretch;\n    height: 100%;\n}\n\n.dashboard.mediaGallery {\n    padding: 30px 30px 100px;\n}\n\n.mediaGallery .modalHeader {\n    margin-top: -5px;\n}\n\n.modalPopup .contentrow {\n    padding: 20px 24px;\n    border-bottom: 1px solid var(--lightgrey);\n}\n\n.mediaGallery button.selectFields,\n.mediaGallery .media-grid-layout {\n    background-color: var(--white);\n}\n\n.mediaGallery .uploadFileBlock {\n    padding: 20px 10px;\n}\n\n.mediaGallery .newPageImageUploadText {\n    padding-top: 0;\n    margin-bottom: 0;\n    text-align: center;\n}\n\n.modalPopup .mediaGallery {\n    max-width: 1076px;\n    margin: 0 auto;\n    border: 1px solid var(--lightgrey);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    background-color: var(--white);\n    width: calc(100% - 30px);\n    position: relative;\n}\n\n.modalPopup .popupBlock {\n    max-width: 1076px;\n    margin: auto;\n    background-color: var(--white);\n    padding: 0;\n    border: 1px solid var(--lightgrey);\n    border-radius: 6px;\n    width: calc(100% - 30px);\n    position: relative;\n}\n\n.mediaGallery .modalPopup {\n    padding: 0;\n    border: none;\n    margin-top: 20px;\n}\n\n.mediaGallery .welcomeModal .primary-button {\n    width: 50%;\n}\n\n.mediaGallery .welcomeModal .primary-button {\n    padding: 8px 13px;\n}\n\n.modalPopup .mediaGallery .popupClose {\n    cursor: pointer;\n    margin-top: 15px;\n    position: absolute;\n    right: 15px;\n}\n\n.mediaGallery .deleteIcon img {\n    top: 0;\n}\n\n.mediaGallery .pagesSearchgridIcon,\n.mediaGallery .pagesSearchlistIcon {\n    cursor: pointer;\n}\n\n.mediaGallery .pagesSearchbtn .pagesbtn {\n    background-color: var(--black);\n}\n\n.mediaGallery .ulpoadImageBlock {\n    padding-left: 36px;\n    padding-right: 36px;\n}\n\n.mediaGallery .uploadingQueue .uploadThumbnail {\n    background-color: var(--frostedwhite);\n}\n\n.mediaGallery .uploadingQueue .uploadThumbnail img {\n    opacity: 0;\n}\n\n\n.pageSearchInput {\n    position: relative;\n}\n\n.pageSearchInput img.pageSearchIcon {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.pageSearchInput input {\n    max-width: 400px;\n    width: 100%;\n    height: 42px !important;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 5px 5px 6px 40px;\n    outline: none;\n    right: 15px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.pageSearchInput img {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.pageSearchInput input::placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grey);\n}\n\n.newpageImageUpload.draging {\n    border-color: var(--purple);\n}\n\n.modalPopup .file {\n    width: calc(50% - 4px);\n    position: relative;\n}\n\n.modalPopup .preview {\n    width: 50%;\n}\n\n.modalPopup .modalImg {\n    text-align: center;\n    padding: 24px 19px 14px 24px;\n    height: calc(100% - 58px);\n    max-height: calc(404px + 91px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.modalPopup .modalImg img {\n    width: auto;\n    height: auto;\n    border-radius: 0;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.modalPopup .modalImg.type-doc img {\n    object-fit: none;\n}\n\n.edit-media-popup .popupBlock-wrapper {\n    background-color: var(--white);\n    border-radius: 6px;\n}\n\n.modalPopup .modalInput::placeholder {\n    color: var(--fiord);\n}\n\n.modalPopup .modalInput::-ms-input-placeholder {\n    color: var(--fiord);\n}\n\n.modalPopup .modalInput {\n    cursor: unset;\n    width: 70%;\n    padding: 10px;\n    border: 1px solid var(--lightgrey) !important;\n    border-radius: 5px;\n    margin-right: 0;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--fiord);\n    outline: none;\n    min-height: 40px;\n    resize: none;\n}\n.modalPopup .modalInput.error-border {\n    border-color: #d92d20 !important;\n}\n\n.modalPopup .title,\n.modalPopup .formContent label,\n.modalPopup .formContentbtn,\n.file-wrapper .title,\n.file-wrapper .formContent label,\n.file-wrapper .formContentbtn {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--charcoalblue);\n}\n\n.modalPopup .formContent {\n    margin-bottom: 16px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n}\n\n.modalPopup .formContent.fromDesc {\n    align-items: flex-start;\n}\n\n.modalPopup .formContent label {\n    width: 100px;\n    margin-right: 10px;\n}\n\n.modalPopup .formContent .formURL {\n    width: calc(100% - 130px);\n    position: relative;\n}\n\n.modalPopup .formContent .formURL .modalInput {\n    width: 100%;\n    padding-right: 60px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.modalPopup .modalContent {\n    min-height: 370px;\n    padding: 15px 24px;\n}\n\n.modalPopup .contentrow {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    gap: 10px 20px;\n    flex-wrap: wrap;\n    padding: 24px;\n}\n\n.modalPopup .modalContent .contentrow {\n    padding: 0 0 15px;\n}\n\n.modalPopup .subtext {\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--fiord);\n    margin-left: 6px;\n}\n\n.modalPopup .modalContentform {\n    padding: 15px 0 0;\n}\n\n.modalPopup .formUrlImg {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-top: 12px;\n    margin-right: 12px;\n    gap: 10px;\n}\n\n.modalPopup .formUrlImg a {\n    display: inline-block;\n    vertical-align: top;\n    transition: all 0.2s linear;\n    opacity: 1;\n}\n\n.modalPopup .formUrlImg a:hover {\n    opacity: 0.5;\n}\n\n.modalPopup .modalHeader,\n.modalPopup .contentrow {\n    border-bottom: 1px solid var(--lightgrey);\n    padding: 20px 24px;\n    margin: 0;\n}\n\n.modalPopup .filename,\n.modalPopup .previewname {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.2;\n    color: var(--charcoalblue);\n    word-break: break-all;\n    padding-right: 15px;\n    margin: 0;\n}\n\n.modalPopup .filename {\n    padding-right: 0;\n}\n\n.modalPopup .popupBlock:after {\n    content: \"\";\n    background-color: #eaecf0;\n    width: 1px;\n    height: 100%;\n    left: -10px;\n    right: 0;\n    margin: 0 auto;\n    position: absolute;\n    top: 0;\n}\n\n.modalPopup .popupBlock .popupBlock-wrapper {\n    padding: 0;\n    background-color: transparent;\n    margin: 5px 5px 5px 0;\n}\n\n.modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {\n    width: 100%;\n    background-color: transparent;\n    border: none;\n}\n\n.modalPopup .popupBlock-wrapper .tooltip-text:after {\n    content: \"\";\n    position: absolute;\n    bottom: 100%;\n    right: 30px;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent var(--mistygray) transparent;\n}\n\n.modalPopup .popupBlock-wrapper .tooltip-text {\n    position: absolute;\n    right: 10px;\n    font-size: 11px;\n    background: var(--white);\n    color: var(--cloudburst);\n    padding: 6px 8px;\n    border-radius: 6px;\n    font-weight: 500;\n    box-shadow: var(--tooltipboxshadow);\n}\n\n.modalPopup .btnGroupLink {\n    text-align: center;\n    margin-top: 0;\n    border-top: 1px solid var(--lightgrey);\n    padding: 24px 24px 19px;\n    justify-content: space-between;\n}\n\n.modalPopup .btnGroupLink button{\n    max-width: 50%;\n}\n\n.modalPopup .btnGroupLink .cancel-btn{\n    background-color: var(--white);\n    color: #000;\n    border: 1px solid var(--grey);\n    box-shadow: var(--boxshadow);\n}\n\n.modalPopup .modalActionsButtons,\n.modalContent .modalActionsButtons ,\n.modalPopup .modalDelete{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 20px;\n}\n\n.modalActionsButtons .modalDelete .settingPage-loader {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    bottom: 0;\n    margin-right: 8px;\n    min-width: unset;\n}\n\n.modalActionsButtons .modalDelete .ring-loader {\n    margin: 0;\n    top: 2px;\n}\n\n.modalActionsButtons .modalDelete .ring-loader::before {\n    border-color: var(--charcoalblue);\n    border-width: 2px;\n}\n\n.btnGroupLink button{\n    width: 50%;\n    max-width: unset;\n}\n\n.modalPopup .modalDelete{\n    gap: 0px;\n    cursor: pointer;\n}\n\n.modalPopup .modalDelete img {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 8px;\n}\n\n.modalPopup .modalDelete .settingPage-loader,\n.modalActionsButtons .modalDelete .settingPage-loader {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    bottom: 0;\n    margin-right: 8px;\n    min-width: unset;\n}\n\n.modalPopup .modalDelete .ring-loader,\n.modalActionsButtons .modalDelete .ring-loader {\n    margin: 0;\n    top: 2px;\n}\n\n.modalPopup .modalDelete .ring-loader:before,\n.modalActionsButtons .modalDelete .ring-loader::before {\n    border-color: var(--charcoalblue);\n    border-width: 2px;\n}\n\n.modalPopup .modalDelete .formContentbtn {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.mediaPopupContainer {\n    position: fixed;\n    z-index: 99;\n    top: 0;\n    display: flex;\n    margin: auto;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n}\n\nhtml:has(.mediaPopupContainer) {\n    overflow: hidden;\n}\n\n\n.addNewMediaButton {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    padding: 10px;\n    cursor: pointer;\n    box-shadow: 0 1px 3px #0000001a;\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n}\n\n.modalPopup .desktop-view {\n    display: flex;\n}\n\n.modalPopup .mobile-view{\n    display: none;\n}\n\n@media screen and (max-width: 1100px) {\n    .modalPopup .modalImg {\n        padding: 24px 24px 19px;\n    }\n\n    .modalPopup .formContent .formURL {\n        width: calc(100% - 152px);\n    }\n\n    .modalPopup .modalContent,\n    .modalPopup .contentrow {\n        padding: 15px;\n        padding: 15px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .modalPopup .popupBlock .popupBlock-wrapper .mediaGallery .modalActions input {\n        padding: 8px 13px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .modalPopup .file .modalHeader {\n        border-top: none;\n        padding-right: 35px;\n    }\n\n    .modalPopup .modalInput {\n        width: calc(100% - 80px);\n    }\n\n    .modalPopup .formContent .formURL {\n        width: calc(100% - 80px);\n    }\n\n    .modalPopup .formContent {\n        gap: 10px;\n    }\n\n    .modalPopup .modalContent {\n        padding: 15px 24px 6px 24px;\n    }\n\n    .modalPopup .contentrow {\n        padding: 0 0 15px 0;\n    }\n\n    .modalPopup .modalHeader {\n        padding: 20px 24px;\n    }\n\n    .modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {\n        height: 100%;\n        margin: 0;\n    }\n}\n\n@media screen and (max-width: 980px) {\n    .pageSearchInput input {\n        right: 0px;\n        width: calc(100% - 20px);\n    }\n\n    .pageSearchInput img {\n        position: absolute;\n        left: 15px;\n        top: 13px;\n    }\n}\n\n@media screen and (max-width: 840px) {\n    .pageSearchInput input {\n        right: 0px;\n    }\n\n    .pageSearchInput img {\n        left: 15px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .modalPopup .desktop-view {\n        display: none;\n    }\n\n    .modalPopup .mobile-view{\n        display: flex;\n    }\n\n    .mediaGallery .pagesSearch {\n        flex-direction: column;\n    }\n\n    .mediaGallery .pagesSearch .pagesSearchIcon {\n        justify-content: flex-start;\n        display: flex;\n        align-items: center;\n        width: 100%;\n        flex-wrap: wrap;\n        margin-top: 20px;\n    }\n\n    .mediaGallery .pageSearchInput .inputFields {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .mediaGallery .pagesSearch .list-search input[type=\"checkbox\"] {\n        width: auto;\n    }\n\n    .mediaGallery .modalPopup {\n        margin-top: 0;\n    }\n\n    .modalPopup .mediaGallery {\n        flex-direction: column;\n        overflow-y: auto;\n        padding: 0;\n        width: calc(100% - 20px);\n        margin: 10px auto;\n        padding-bottom: 0;\n        margin: 10px;\n        height: calc(100% - 20px);\n    }\n\n    .modalPopup .mediaGallery .popupClose {\n        position: absolute;\n        top: 17px;\n        right: 20px;\n        display: block;\n        margin-top: 0;\n    }\n\n    .mediaGallery .pageSearchTop .dropdown-wrapp {\n        width: calc(50% - 5px);\n    }\n\n    .mediaGallery .pageSearchTop .dropdown-wrapp button {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .mediaGallery .dropdown.addDropdown {\n        width: 100%;\n    }\n\n    .mediaGallery .pageSearchTop, .mediaGallery .pageSearchTop .pageSearchInput {\n        width: 100%;\n    }\n\n    .mediaGallery .ulpoadImageBlock {\n        padding-left: 18px;\n        padding-right: 18px;\n    }\n\n    .pageSearchInput input {\n        right: 0px;\n    }\n\n    .pageSearchInput img {\n        left: 15px;\n    }\n\n    .modalPopup .file {\n        width: 100%;\n        border-right: 0;\n    }\n\n    .modalPopup .preview {\n        width: 100%;\n    }\n\n    .modalPopup .formContent {\n        gap: 5px;\n    }\n\n    .modalPopup .popupBlock:after {\n        display: none;\n    }\n\n    .modalPopup .popupBlock .popupBlock-wrapper {\n        height: max-content;\n    }\n\n    .modalPopup .popupBlock .popupBlock-wrapper .mediaGallery {\n        flex-direction: column;\n    }\n\n    .modalPopup .modalContent{\n        min-height: unset;\n    }\n}\n\n@media screen and (max-width: 560px) {\n    .modalPopup .formContent:last-child label {\n        width: 100px;\n    }\n\n    .modalPopup .modalInput,\n    .modalPopup .formContent .formURL {\n        width: calc(100% - 105px);\n    }\n\n    .modalPopup .modalInput {\n        margin-right: 0 !important;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .modalPopup .popupBlock .popupBlock-wrapper {\n        height: calc(100dvh - 30px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
